export const COUNTRY_CODE_NAME_DICT: Record<string, string> = {
   af: 'ChIJbQL_-LZu0TgReNqWvg1GtfM',
   al: 'ChIJLUwnvfM7RRMR7juY1onlfAc',
   dz: 'ChIJ0XsDKGqKfg0RovjXq-O-QHE',
   ad: 'ChIJlfCemC71pRIRkn_qeNc-yQc',
   ao: 'ChIJJ4utyk7yURoRPU5KDZ0oClk',
   ai: 'ChIJ5QHvjnRjDowRgdTghNNqnTs',
   aq: 'ChIJ4Ql4Koj_nbARx8fIXTgKjbA',
   ag: 'ChIJwdG4bbluDYwRlHmL4Yg3aic',
   sa: 'ChIJQSqV5z-z5xURm7YawktQYFk',
   ar: 'ChIJZ8b99fXKvJURqA_wKpl3Lz0',
   am: 'ChIJx7pz54RWFUARIy2C63p1tNA',
   aw: 'ChIJ23da4s84hY4RL4yBiT6KavE',
   au: 'ChIJ38WHZwf9KysRUhNblaFnglM',
   at: 'ChIJfyqdJZsHbUcRr8Hk3XvUEhA',
   az: 'ChIJ3x2iGtl8MEARCM2DPmtSyeY',
   bs: 'ChIJPQ9Isjua1ogR5XnHaoO0PhM',
   bh: 'ChIJEaJHak5SSD4RRhDa2-JQlC4',
   bd: 'ChIJp4vhgO2qrTARa_zhxOAoLQ8',
   bb: 'ChIJoxoyrvvxQ4wRKzb0jLNR7A4',
   be: 'ChIJl5fz7WR9wUcR8g_mObTy60c',
   bz: 'ChIJ-foSwT5bXI8RTuMeP02KSvY',
   bj: 'ChIJlVZ6BCtUIxAR9S5iy_h3suw',
   bm: 'ChIJpbBohp4TLYoRvLiZLMf93zw',
   bt: 'ChIJz5XFc6WSWzcR2rw2KGWsDLs',
   by: 'ChIJgUit4oQl2kYREIzsgdGhAAA',
   mm: 'ChIJBylOcadSVjAREStiHOQOe7o',
   bo: 'ChIJlaK7d4nfXpERv-0VAbvCnhw',
   bq: 'ChIJt7kdj4sYIowRz7WDIdc1beE',
   ba: 'ChIJ16k3xxWiSxMRDOm3QwPi920',
   bw: 'ChIJESJF0SFDpB4Re68Vhyp8ZPE',
   br: 'ChIJzyjM68dZnAARYz4p8gYVWik',
   bn: 'ChIJ0bm4BEuZGDIR1toJ3YA1_l0',
   io: 'ChIJh6OdhOBzkiQR4WsfEHBkT6k',
   vg: 'ChIJzVNkK5xzBYwRPTvsse5woG0',
   bg: 'ChIJifBbyMH-qEAREEy_aRKgAAA',
   bf: 'ChIJm3Cm1SbKLQ4Rq22DRu0Kkyc',
   bi: 'ChIJW_FUNtNEwRkRjewxVg5NI7E',
   cl: 'ChIJL68lBEHFYpYRHbkCERPhBQU',
   cn: 'ChIJwULG5WSOUDERbzafNHyqHZU',
   hr: 'ChIJ7ZXdCghBNBMRfxtm4STA86A',
   cw: 'ChIJx_3HYr6dhI4RI0fG2yiSf_w',
   cy: 'ChIJVU1JymcX3hQRbhTEf4A8TDI',
   td: 'ChIJYXNnvXg55xARnIDAzluDYDs',
   me: 'ChIJyx8sJBcyTBMRRtP_boadTDg',
   cz: 'ChIJQ4Ld14-UC0cRb1jb03UcZvg',
   um: 'ChIJBQ-2twOlemQREDZxw68t4QQ',
   dk: 'ChIJ-1-U7rYnS0YRzZLgw9BDh1I',
   cd: 'ChIJvUZ1ms_6eRkRQfGTrF4-xgQ',
   dm: 'ChIJ9bbx3jiIr44R4PcNBiQPAqY',
   do: 'ChIJ9bbx3jiIr44R4PcNBiQPAqY',
   dj: 'ChIJAfb5NGfUIhYRiFsP76e7chQ',
   eg: 'ChIJ6TZcw3aJNhQRRMTEJQmgRSw',
   ec: 'ChIJ1UuaqN2HI5ARAjecEQSvdp0',
   er: 'ChIJZYW6nT9abRYR-g4SL_AIwhc',
   ee: 'ChIJ_UuggpyUkkYRwyW0T7qf6kA',
   et: 'ChIJK_1s3c7QNRYRWsVIU3-m9ns',
   fk: 'ChIJo-ORRLmJKrwROsXZjf-qKjI',
   fj: 'ChIJXdw8cP2QGW4Rk1vvRpkxnJ4',
   ph: 'ChIJY96HXyFTQDIRV9opeu-QR3g',
   fi: 'ChIJ3fYyS9_KgUYREKh1PNZGAQA',
   fr: 'ChIJMVd4MymgVA0R99lHx5Y__Ws',
   tf: 'ChIJN8QJBD7EFLMRKdDmkEwhirg',
   ga: 'ChIJ7fM4VIo7fxARFWt4Ng7DDHs',
   gm: 'ChIJBzivZSmcwg4RKp0Ta0BMSp4',
   gs: 'ChIJJXmoUuK2PbkRvbBNiNp8434',
   gh: 'ChIJx9baqM1a1w8RNtKT0DDy11Q',
   gi: 'ChIJNb4UJ3a_DA0RD4cANiYlTjg',
   gr: 'ChIJY2xxEcdKWxMRHS2a3HUXOjY',
   gd: 'ChIJ0XuH9IkXOIwRjk8fWgHH2DY',
   gl: 'ChIJFXfA47sNok4RGOIUAYOdzzQ',
   ge: 'ChIJa2JP5tcMREARwkotEmR5kE8',
   gu: 'ChIJ7yQPk_92H2cRpuWzxZGucVU',
   gg: 'ChIJ7bO_9OQgDUgRmZgNXYrVCpk',
   gf: 'ChIJU9f3hVcVEo0RRvQKD-n3J94',
   gy: 'ChIJU9f3hVcVEo0RRvQKD-n3J94',
   gp: 'ChIJUX0od1p1DowRqwdKtzc-vuw',
   gt: 'ChIJa1DnNlATiIURu9WEWzcrmDU',
   gw: 'ChIJ8amCr3Q85A4RTggeVz-O6Ls',
   gq: 'ChIJp4euX2A6ZBARet4QLKKicMg',
   gn: 'ChIJP5XOvCGzAQ8R9i1a18t7c-g',
   ht: 'ChIJEbvLf_PGto4R0_ZUTLI4FLU',
   es: 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
   nl: 'ChIJu-SH28MJxkcRnwq9_851obM',
   hn: 'ChIJzzG3cxp1ao8RZIL7toLe0X4',
   hk: 'ChIJD5gyo-3iAzQRfMnq27qzivA',
   in: 'ChIJkbeSa_BfYzARphNChaFPjNc',
   id: 'ChIJtwRkSdcHTCwRhfStG-dNe-M',
   iq: 'ChIJEUr1VD2CVxURAhYGorthpW0',
   ir: 'ChIJ8R1rwS7s9z4RzvpRntOVsEA',
   ie: 'ChIJ-ydAXOS6WUgRCPTbzjQSfM8',
   is: 'ChIJQ2Dro1Ir0kgRmkXB5TQEim8',
   il: 'ChIJi8mnMiRJABURuiw1EyBCa2o',
   jm: 'ChIJnXHPxhsq2o4R-g4StcDRoFk',
   jp: 'ChIJLxl_1w9OZzQRRFJmfNR1QvU',
   ye: 'ChIJX7w0fKzbAxYRrneufjcp8ZI',
   je: 'ChIJM3WSjKRSDEgRw2waCqMjnFE',
   jo: 'ChIJmd5kZkdvABURmU4mUQdbKI0',
   ky: 'ChIJKaq4Lz6GJY8RXnFwh9PERXA',
   kh: 'ChIJQzfc1L-HBzERUxL0ieC_t-Q',
   cm: 'ChIJIQ8-cFM3YRARU5uCmUXEAys',
   ca: 'ChIJ2WrMN9MDDUsRpY9Doiq3aJk',
   qa: 'ChIJf-jc_zTFRT4RMkArgc-I-hw',
   kz: 'ChIJR6n87AcQqTgRGw6z5C-Ee18',
   ke: 'ChIJD5BQg9CAJxgR2W2XobAOO0A',
   kg: 'ChIJ8yfp_B04lzgRM8SITrdYECg',
   ki: 'ChIJA4cCwpF8ZGURB8NSAQR9MoQ',
   co: 'ChIJo5QVrjqkFY4RQKPy7wSaDZo',
   km: 'ChIJjaQIZAPjmBgR29Tf5L5_Cvc',
   cg: 'ChIJCROj3WOlYBoRj2z8FM96AVU',
   kr: 'ChIJm7oRy-tVZDURS9uIugCbJJE',
   kp: 'ChIJN0NP5toCfjURHIYdPhyHCzo',
   cr: 'ChIJJcmsIWLlko8RK5qBNSX3VGI',
   cu: 'ChIJtUx6DwdJzYgRGqQQkVL3jHk',
   kw: 'ChIJoVHqvj82xT8R0u3Yks1rcnQ',
   la: 'ChIJiUWCsFeQFDERgc2ZH0iSxQ4',
   ls: 'ChIJ64xf1idIjB4Rsx7ReLhXLSM',
   lb: 'ChIJraoihAIXHxURcPkAbAk0fcw',
   lr: 'ChIJwfyp1AP4CQ8Rc2PRMmso038',
   ly: 'ChIJDQHOjtmSqBMRKsL5x0FgB_o',
   li: 'ChIJ_S9HHUQxm0cRibFa3Ta16mA',
   lt: 'ChIJE74zDxSU3UYRubpdpdNUCvM',
   lu: 'ChIJRyEhyrlFlUcR75LTAvZg22Q',
   lv: 'ChIJ_ZqKe2cw6UYREPzyaM3PAAA',
   mk: 'ChIJCUi8cJ8VVBMRscUfyNZa8uA',
   mg: 'ChIJRYUj6uOk0SERiBN7l8HjRFI',
   yt: 'ChIJu43y3DMOCiIRSyr-lWcXMv8',
   mo: 'ChIJ88g14uB6ATQR9qyFtCzje8Y',
   mw: 'ChIJ18ATk91b2BgRQ4VmKRcuo0Q',
   mv: 'ChIJvXv7qr-ZtSQRiWKVgeEJRUE',
   my: 'ChIJrzBnX5fTNDAR2BwhKJOWRQc',
   ml: 'ChIJz3MQG4g-FA4RgM-9oOJbOrs',
   mt: 'ChIJxUeGHShFDhMROUK-NmHYgvU',
   mp: 'ChIJUVyZkDSx2GYRMg46fKvrt50',
   ma: 'ChIJjcVRlmGICw0Rw_8sxIGT09k',
   mq: 'ChIJDQdmAPmgaowRsOevFxIbAOE',
   mr: 'ChIJTzmzFMO4gA4RTlO-1usLIoM',
   mu: 'ChIJyXRE-U1QfCERMdBrEcLZA0I',
   mx: 'ChIJU1NoiDs6BIQREZgJa760ZO0',
   fm: 'ChIJE8hYrMW12WURJWWk-s2NelQ',
   md: 'ChIJoWm3KDZ8yUARy6xT36wZgSU',
   mc: 'ChIJMYU_e2_CzRIR_JzEOkx493Q',
   mn: 'ChIJS22qaQYFJzYRluDmNzkh3eA',
   ms: 'ChIJnTbH4VOrE4wRorEFiIPqDx4',
   mz: 'ChIJxUr95uqs1BgRFaEWrrm_uxI',
   na: 'ChIJIXXTbn489RsRYbLsqKXludM',
   nr: 'ChIJTVvkHR8cfW8RgQrUxfSd2Vk',
   np: 'ChIJz2gufcfolTkR3obM0LyaojQ',
   de: 'ChIJa76xwh5ymkcRW-WRjmtd6HU',
   ne: 'ChIJDY2kfa8LThARyAvFaEH-qJk',
   ng: 'ChIJDY2kfa8LThARyAvFaEH-qJk',
   ni: 'ChIJzSL_zgDCEI8RtRWsP-Wn-sg',
   nu: 'ChIJO7duNyolnXERGIvcezR4QpE',
   nf: 'ChIJRcoiUzqXuokRCh56zn8Qmas',
   no: 'ChIJv-VNj0VoEkYRK9BkuJ07sKE',
   nc: 'ChIJyzIaP2niJ2wR7HqT1Y_20PY',
   nz: 'ChIJh5Z3Fw4gLG0RM0dqdeIY1rE',
   om: 'ChIJv5vVqWaf1j0RF6ixZXZMBjo',
   pk: 'ChIJH3X9-NJS2zgRXJIU5veht0Y',
   pw: 'ChIJmQOvorRFhDIRu-uhOd0e7RI',
   ps: 'ChIJ2b1miNLyHBURhvZm0QGgF-4',
   pa: 'ChIJ4yu-yIMVpo8Rz5ulH03g7nk',
   pg: 'ChIJr54Ov6_oWWgRehKcjg3l8No',
   py: 'ChIJYz3xkDQIXJQR8y5YHWH_-rM',
   pe: 'ChIJ9RRZwFDIBZERSAYheRIBnvI',
   pn: 'ChIJiweo3H8POJ4RyJoVGceMnEY',
   pf: 'ChIJTddtfNB1GHQREVfDCXp6wJs',
   pl: 'ChIJuwtkpGSZAEcR6lXMScpzdQk',
   pr: 'ChIJ-aeSGyaWAowRGpsEGCjsNvM',
   pt: 'ChIJ1SZCvy0kMgsRQfBOHAlLuCo',
   tw: 'ChIJL1cHXAbzbjQRaVScvwTwEec',
   za: 'ChIJURLu2YmmNBwRoOikHwxjXeg',
   cf: 'ChIJt6KGjVPpuBARJIBcWgLGm7g',
   cv: 'ChIJMVERWSGPNQkRH-oY-TbyGms',
   re: 'ChIJO-S4EIF3eCER-erb7ImOf0o',
   ru: 'ChIJ-yRniZpWPEURE_YRZvj9CRQ',
   ro: 'ChIJw3aJlSb_sUARlLEEqJJP74Q',
   rw: 'ChIJ40A451SWwhkRA6HMyyawkHQ',
   kn: 'ChIJDXKKxm4ZEowR6IYdmsaa6d4',
   lc: 'ChIJHaMt8WVgQIwR9Z056MSGdG4',
   vc: 'ChIJuzU5nuKsQIwRsaHSjejT_TE',
   bl: 'ChIJnej-KlR1DowR5nUq6msRdAE',
   mf: 'ChIJ_U5xCKxvDowRp4huTgqDGbk',
   pm: 'ChIJ0VcO-0tLbEsREVxs6jdncZw',
   sv: 'ChIJVwZkWaYnY48RMkiFmOsWmm8',
   as: 'ChIJyf1IkreEpnER3UuuLZ5z7vM',
   ws: 'ChIJAxDsZKMTpXERcnhhdJYMh6Y',
   sm: 'ChIJeT_m9V_rLBMRECA0gpnzAAA',
   sn: 'ChIJcbvFs_VywQ4RQFlhmVClRlo',
   rs: 'ChIJlYCJ8t8dV0cRXYYjN-pQXgU',
   sc: 'ChIJO62-cP0hXCIR99pJ06DQ0zI',
   sl: 'ChIJQ_OrOhgGAQ8RGfcsx83paVM',
   sg: 'ChIJdZOLiiMR2jERxPWrUs9peIg',
   sx: 'ChIJw5D41mJuDowRQo8zJsIsi3I',
   sk: 'ChIJf8Z8rrlgFEcRfTpysWdha80',
   si: 'ChIJYYOWXuckZUcRZdTiJR5FQOc',
   so: 'ChIJg1vR7KcuHRgRvuXpXM46OZ4',
   lk: 'ChIJnR5a9jxZ4joRjNPiALSkPeE',
   us: 'ChIJCzYy5IS16lQRQrfeQ5K5Oxw',
   sz: 'ChIJBw8yR-HO6B4RaXANGC_GPcE',
   sd: 'ChIJlbFyEMQc2RURNythKkZwv9I',
   sr: 'ChIJUdXT2dU2CI0RsjYpccDhNxA',
   sj: 'ChIJgQmY0JVjd0URQdKkzJ42A4U',
   sy: 'ChIJp8Y8QdzmGBURIPYqiPRGdYc',
   ch: 'ChIJYW1Zb-9kjEcRFXvLDxG1Vlw',
   se: 'ChIJ8fA1bTmyXEYRYm-tjaLruCI',
   tj: 'ChIJzbO8enN2sTgRtYgZT4QxwyU',
   th: 'ChIJsU1CR_eNTTARAuhXB4gs154',
   tz: 'ChIJEaFpSDFRSxgRMMTBSzEXWog',
   tl: 'ChIJKaHkhgnl_SwRPFvoh4PG5QM',
   tg: 'ChIJGVQYE8HhIxARYJPRGjBbrvo',
   tk: 'ChIJ9x14s6omUnARN5vbbUZicI8',
   to: 'ChIJHdCfu0S2k3ERqeJexcrMbfM',
   tt: 'ChIJxbZQY5cHNowRJ_E5xlUoCP8',
   tn: 'ChIJ4aQWg0SVVRIR75sBqjozhDo',
   tr: 'ChIJcSZPllwVsBQRKl9iKtTb2UA',
   tm: 'ChIJy2y8dFXLZT8RkaRpQWuC3X4',
   tc: 'ChIJdWu7vlVfS4kR3sGNAoDHEX4',
   tv: 'ChIJTaCxWbmcwW8RLhIHB2hUZ48',
   ug: 'ChIJRfmZZJ-mcRcRSUUBQ85VQYc',
   ua: 'ChIJjw5wVMHZ0UAREED2iIQGAQA',
   uy: 'ChIJCd5f-zoHdZURSlIWYGGWVUo',
   uz: 'ChIJsXbWpSCLrjgRIB6Efq1tCso',
   vu: 'ChIJE2CSyF5giW4RaibQvs85gzQ',
   wf: 'ChIJPUsabgaxyHERGwrSj-wYyRY',
   va: 'ChIJPS3UVwqJJRMRsH46sppPCQA',
   ve: 'ChIJAdjLNstTKIwR003VfFjyoNw',
   hu: 'ChIJw-Q333uDQUcREBAeDCnEAAA',
   gb: 'ChIJqZHHQhE7WgIReiWIMkOg-MQ',
   vn: 'ChIJXx5qc016FTERvmL-4smwO7A',
   it: 'ChIJA9KNRIL-1BIRb15jJFz1LOI',
   ci: 'ChIJZ6BJsIcTlg8RQO65fGIe-QE',
   bv: 'ChIJP747leE0g7cRS7j-ENe4oLY',
   cx: 'ChIJz6fA4yea9S4RFup1BAnW5xU',
   im: 'ChIJ1YEuRDCFY0gRDeDw8bxbAuo',
   sh: 'ChIJm9z2Gho7WgIR266Y3JUt7mk',
   ax: 'ChIJGevhxGjkikYR7Y5Cc4P2Q80',
   ck: 'ChIJ3d57ue-KVHER2LQIiA6lTAI',
   vi: 'ChIJuaza8mUQBYwRBRzFGx2JHfk',
   hm: 'ChIJ_SuSiEtSAbMRfnaz5cLaHSY',
   cc: 'ChIJwWnofonFDi8Rpp_jEPBC0ds',
   mh: 'ChIJK8opIbIZAWURdrcJqugDPos',
   fo: 'ChIJ6_ktdpMVvEgRJBv3ZEgxsD8',
   sb: 'ChIJ0QlQVeBR02gRgClEF6DATLQ',
   st: 'ChIJidiaC_nscBAR6jB2VQwjUWI',
   zm: 'ChIJcQv8_KX0QBkRRT5Yfqz5n_E',
   zw: 'ChIJYXGxBuekMRkR7r_LxV84wKE',
   ae: 'ChIJvRKrsd9IXj4RpwoIwFYv0zM',
};
